var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0 d-flex align-start",
              class: { "mt-md-n10": !_vm.noMarginTop && !_vm.stackedView },
              attrs: {
                cols: "12",
                md: _vm.stackedView ? 12 : _vm.showFilters ? 4 : 2,
                order: _vm.stackedView ? 2 : 1,
              },
            },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFilters,
                      expression: "showFilters",
                    },
                  ],
                  staticClass: "pb-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mx-0 pt-2 justify-start align-baseline",
                      attrs: { id: "player-seasons" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 header-font py-2",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.filters")))]
                          ),
                          _vm._v(" "),
                          (_vm.currentUser.clientType === "Media" ||
                            _vm.currentUser.clientType === "Driblab") &&
                          !_vm.stackedView
                            ? _c("MediaModeForm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFilters,
                                    expression: "showFilters",
                                  },
                                ],
                                attrs: {
                                  fields: _vm.mediaModeFields,
                                  mediaMode: _vm.mediaMode,
                                  mediaModeData: _vm.mediaModeData,
                                  mediaModeFlags: _vm.mediaModeFlags,
                                  selectorMode: "",
                                },
                                on: {
                                  mediaModeChange: function ($event) {
                                    _vm.mediaMode = $event
                                  },
                                  mediaModeDataChange: function ($event) {
                                    return _vm.onMediaModeDataChange($event)
                                  },
                                  mediaModeFlagsChange: function ($event) {
                                    _vm.mediaModeFlags = $event
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12", md: "8" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mr-5 pt-0 mt-0 primary--text font-weight-bold body-1",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("table.clientLeagues.seasons")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-autocomplete", {
                            ref: "autoCompleteSeasonRef",
                            attrs: {
                              items: _vm.playerSeasonData,
                              "item-value": "compoundId",
                              "item-text": "compoundText",
                              clearable: "",
                              multiple: "",
                              "hide-details": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onSelectChange()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function ({ item, index }) {
                                  return [
                                    index <= 2
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass:
                                              "body-2 mb-1 w-90 black--text",
                                            attrs: {
                                              small: "",
                                              color: "lightSecondary lighten-2",
                                            },
                                          },
                                          [
                                            _c(
                                              "object",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                                  type: "image/png",
                                                  height: "20",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                    height: "20",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-bold text-ellipsis",
                                              },
                                              [_vm._v(_vm._s(item.seasonName))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "mx-1" },
                                              [_vm._v("@")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium",
                                              },
                                              [_vm._v(_vm._s(item.teamName))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index === 3
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text body-2 subheader-font",
                                          },
                                          [
                                            _vm._v(
                                              "(+" +
                                                _vm._s(
                                                  _vm.seasonDataSelectedModel
                                                    .length - 3
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("finishingMap.more")
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass:
                                          "pa-0 primary--text body-2 font-weight-medium d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "object",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "d-flex flex-column" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.seasonName) +
                                                "\n                    "
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(item.teamName)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.seasonDataSelectedModel,
                              callback: function ($$v) {
                                _vm.seasonDataSelectedModel = $$v
                              },
                              expression: "seasonDataSelectedModel",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-1 pl-1",
                          attrs: { cols: "12", md: "4" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "pa-0 mr-0 body-1 font-weight-bold primary--text flex-shrink-0",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("general.filter")) +
                                  " " +
                                  _vm._s(_vm.$t("searchbar.games"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 flex-shrink-1" },
                            [
                              _c("v-autocomplete", {
                                staticClass: "pa-0 body-2 mb-2",
                                attrs: {
                                  clearable: "",
                                  "hide-details": "",
                                  dense: "",
                                  items: _vm.grounds,
                                  "item-text": "name",
                                  "item-value": "id",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onSelectChange()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function ({ item, index }) {
                                      return [
                                        index <= 0
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass:
                                                  "body-2 mb-1 w-80 d-flex justify-center black--text",
                                                attrs: {
                                                  small: "",
                                                  color:
                                                    "lightSecondary lighten-2",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text-ellipsis",
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(_vm._s(item.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.groundModel,
                                  callback: function ($$v) {
                                    _vm.groundModel = $$v
                                  },
                                  expression: "groundModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "pa-0 mr-4 body-1 font-weight-bold primary--text flex-shrink-0",
                            },
                            [_vm._v(_vm._s(_vm.$t("searchbar.games")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 flex-shrink-1" },
                            [
                              _c("v-autocomplete", {
                                staticClass: "pa-0 body-2 mb-2",
                                attrs: {
                                  clearable: "",
                                  multiple: "",
                                  "menu-props": "auto",
                                  "hide-details": "",
                                  dense: "",
                                  items: _vm.gamesFiltered,
                                  "item-text": "name",
                                  "item-value": "gameId",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: { ripple: "" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                              },
                                              click: _vm.toggleGames,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "py-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "body-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "finishingMap.selectAll"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selection",
                                    fn: function ({ item, index }) {
                                      return [
                                        index <= 0
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass:
                                                  "body-2 mb-1 black--text",
                                                attrs: {
                                                  small: "",
                                                  color:
                                                    "lightSecondary lighten-2",
                                                },
                                              },
                                              [
                                                _c(
                                                  "object",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`,
                                                      type: "image/png",
                                                      height: "20",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                        height: "20",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text-ellipsis",
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "object",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`,
                                                      type: "image/png",
                                                      height: "20",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                        height: "20",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "primary--text body-2 subheader-font",
                                              },
                                              [
                                                _vm._v(
                                                  "(+" +
                                                    _vm._s(
                                                      _vm.gamesModel.length - 1
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.more"
                                                      )
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "object",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(_vm._s(item.name)),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "object",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              data: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`,
                                              type: "image/png",
                                              height: "20",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`,
                                                height: "20",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.gamesModel,
                                  callback: function ($$v) {
                                    _vm.gamesModel = $$v
                                  },
                                  expression: "gamesModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _vm.$vuetify.breakpoint.smAndDown
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex pb-3 pl-0 justify-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "body-2",
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    outlined: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showShotOptions = !_vm.showShotOptions
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.showShotOptions
                                          ? _vm.$t(
                                              "game.detail.hidePassOptions"
                                            )
                                          : _vm.$t(
                                              "game.detail.showPassOptions"
                                            )
                                      ) +
                                      " "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showShotOptions
                                            ? "keyboard_arrow_up"
                                            : "keyboard_arrow_down"
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        {
                          staticClass: "mx-0",
                          attrs: { id: "passing-location" },
                        },
                        [
                          _vm.showShotOptions
                            ? _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 mb-n2 primary--text font-weight-bold body-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("general.visualization"))
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showShotOptions
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pt-0 pb-2 d-flex flex-wrap",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "pa-0 me-5",
                                    attrs: {
                                      label: _vm.$t("finishingMap.circles"),
                                      color: "secondary",
                                      value: "circles",
                                      "hide-details": "",
                                    },
                                    on: { change: _vm.updateShots },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.circles"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      561737895
                                    ),
                                    model: {
                                      value: _vm.checkboxCircles,
                                      callback: function ($$v) {
                                        _vm.checkboxCircles = $$v
                                      },
                                      expression: "checkboxCircles",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    staticClass: "pa-0",
                                    attrs: {
                                      label: _vm.$t("finishingMap.boxes"),
                                      color: "secondary",
                                      value: "boxes",
                                      "hide-details": "",
                                    },
                                    on: { change: _vm.updateShots },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.boxes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3586374085
                                    ),
                                    model: {
                                      value: _vm.checkboxCircles,
                                      callback: function ($$v) {
                                        _vm.checkboxCircles = $$v
                                      },
                                      expression: "checkboxCircles",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mx-0", attrs: { id: "shot-filters" } },
                    [
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1",
                                },
                                [_vm._v(_vm._s(_vm.$t("finishingMap.areas")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-2 my-1",
                                  attrs: {
                                    small: "",
                                    rounded: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSelectAreaClick()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "white", "x-small": "" },
                                    },
                                    [_vm._v("filter_list")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ms-1" }, [
                                    _vm._v(
                                      _vm._s(
                                        `${_vm.$t(
                                          "areaSelector.filterAreas"
                                        )} (${_vm.areaModel.length}/${
                                          _vm.currentUserAreas.length
                                        })`
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.player
                                ? _c("AreaSelectorModal", {
                                    ref: "areaSelectorModalRef",
                                    attrs: {
                                      title: `${_vm.$t(
                                        "playerDetail.keyPassMap"
                                      )} - ${_vm.$t(
                                        "areaSelector.selectAreas"
                                      )}`,
                                      areaModel: _vm.areaModel,
                                      isVertical: true,
                                    },
                                    on: {
                                      onConfirmClick: function ($event) {
                                        return _vm.onAreaSelectorConfirm($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.typesOfShot"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    items: _vm.shotTypes,
                                    "item-text": "text",
                                    "item-value": "id",
                                    multiple: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateShots()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            index === 0
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        "lightSecondary lighten-2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "black--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(+" +
                                                        _vm._s(
                                                          _vm.shotTypeModel
                                                            .length - 1
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "finishingMap.more"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 primary--text",
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    177504760
                                  ),
                                  model: {
                                    value: _vm.shotTypeModel,
                                    callback: function ($$v) {
                                      _vm.shotTypeModel = $$v
                                    },
                                    expression: "shotTypeModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleShotTypes },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.shotStrategy"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    clearable: "",
                                    "hide-details": "",
                                    dense: "",
                                    items: _vm.shotStrategies,
                                    "item-text": "text",
                                    "item-value": "id",
                                    multiple: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onStrategyInput()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            !item.isGroupHeader
                                              ? [
                                                  index === 0
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color:
                                                              "lightSecondary lighten-2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "black--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.text
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : index === 1
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "primary--text body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(+" +
                                                              _vm._s(
                                                                _vm.shotStrategyModel.filter(
                                                                  (id) =>
                                                                    id !==
                                                                      "group_open" &&
                                                                    id !==
                                                                      "group_set"
                                                                ).length - 1
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "finishingMap.more"
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            item.isGroupHeader
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          small: "",
                                                          color: "secondary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.isStrategyGroupSelected(
                                                              item.id
                                                            )
                                                              ? "check_box"
                                                              : "check_box_outline_blank"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-2 primary--text font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 primary--text",
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4192063463
                                  ),
                                  model: {
                                    value: _vm.shotStrategyModel,
                                    callback: function ($$v) {
                                      _vm.shotStrategyModel = $$v
                                    },
                                    expression: "shotStrategyModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleShotStrategies },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.bodyPart"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    clearable: "",
                                    dense: "",
                                    items: _vm.bodyParts,
                                    "item-text": "text",
                                    "item-value": "id",
                                    multiple: "",
                                    "hide-details": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateShots()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            index === 0
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        "lightSecondary lighten-2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "black--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(+" +
                                                        _vm._s(
                                                          _vm.bodyPartModel
                                                            .length - 1
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "finishingMap.more"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 primary--text",
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1154278695
                                  ),
                                  model: {
                                    value: _vm.bodyPartModel,
                                    callback: function ($$v) {
                                      _vm.bodyPartModel = $$v
                                    },
                                    expression: "bodyPartModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleBodyPart },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { id: "filters" } },
                    [
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex py-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c("v-range-slider", {
                                staticClass: "align-center px-3 py-0",
                                attrs: {
                                  label: _vm.$t("finishingMap.minutes"),
                                  "thumb-label": "",
                                  min: _vm.rangeMinutes[0],
                                  max: _vm.rangeMinutes[1],
                                  step: "1",
                                  "hide-details": "",
                                  color: `secondary ${
                                    _vm.$vuetify.theme.dark ? "lighten-3" : ""
                                  }`,
                                },
                                on: { input: _vm.updateShots },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text font-weight-bold body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.minutes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 subheader-font monospace-font",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      `(${_vm.rangeMinutes[0]} - ${_vm.rangeMinutes[1]})`
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1794521083
                                ),
                                model: {
                                  value: _vm.minutes,
                                  callback: function ($$v) {
                                    _vm.minutes = $$v
                                  },
                                  expression: "minutes",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.stackedView
                    ? _c(
                        "div",
                        { staticClass: "pb-2 px-1 mt-5" },
                        [_c("v-divider")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.stackedView
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex justify-end py-0 w-100 pr-1",
                          attrs: { id: "image-download" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsPNG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("PNG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsSVG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("SVG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingExport,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onGenerateIFrameClick()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("share")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Embed")]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-shrink-0 ml-2 align-self-start" },
                [_vm._t("filters-toggle")],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "chart",
              staticClass: "text-center px-0",
              class: { "py-0": _vm.stackedView },
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.stackedView ? 12 : _vm.showFilters ? 8 : 10,
                id: "chart",
                order: _vm.stackedView ? 1 : 2,
              },
            },
            [
              _vm.avatarSize && _vm.mediaMode
                ? _c("PlayerAvatarMedia", {
                    ref: "playerAvatarMediaRef",
                    attrs: {
                      width: _vm.size,
                      height: _vm.avatarSize.height,
                      id: `${_vm.player.playerId}-${this.chartId}`,
                      margin: _vm.margin,
                      title: _vm.mediaModeData.upperText,
                      subtitle: _vm.mediaModeData.lowerText,
                      color: _vm.mediaModeData.borderColor,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      player: _vm.headerPlayer,
                      face: _vm.mediaModeData.face.dataUrl,
                      nationalTeam: _vm.mediaModeData.nationalTeam,
                      type: "keyPassMap",
                      lineDistance: _vm.mediaModeData.lineLength,
                      avatarSize: _vm.mediaModeData.avatarSize,
                      lineWeight: _vm.mediaModeData.lineWeight,
                      upperTextFontSize: _vm.mediaModeData.upperTextFontSize,
                      upperTextFontWeight:
                        _vm.mediaModeData.upperTextFontWeight,
                      lowerTextFontSize: _vm.mediaModeData.lowerTextFontSize,
                      lowerTextFontWeight:
                        _vm.mediaModeData.lowerTextFontWeight,
                      fontFamily: _vm.mediaModeData.fontFamily,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.size != 0
                ? _c("XAChart", {
                    key: _vm.xaMap,
                    ref: "xaChart",
                    attrs: {
                      size: _vm.size,
                      passes: _vm.filteredShots,
                      margin: _vm.margin,
                      type: _vm.type,
                      playerId: _vm.playerId,
                      seasons: _vm.filteredSeasons,
                      playerName: _vm.player.name,
                      circlesAndBoxes: _vm.checkboxCircles,
                      language: _vm.currentUserLanguage,
                      mediaMode: _vm.mediaMode,
                      id: `${_vm.player.playerId}-${this.chartId}`,
                      gameId: _vm.gameId,
                      gameIds: _vm.gameIds.length
                        ? _vm.gameIds
                        : _vm.gamesModel,
                      gameName: _vm.gameName,
                      minsPlayed: _vm.minsPlayed,
                      fontFamily: _vm.mediaModeData.fontFamily,
                      teamId: _vm.teamId || 0,
                      filterShotTypeText: _vm.filterShotTypeText,
                      filterShotStrategyText: _vm.filterShotStrategyText,
                      filterBodyPartText: _vm.filterBodyPartText,
                      filterMinutesText: _vm.filterMinutesText,
                    },
                    on: {
                      sizeChange: function ($event) {
                        return _vm.onChartSizeChange($event)
                      },
                      loaded: function ($event) {
                        return _vm.onLoaded($event)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.avatarSize &&
              _vm.size &&
              _vm.mediaMode &&
              _vm.mediaModeData.socialMedia
                ? _c("DriblabSocialMedia", {
                    ref: "driblabSocialMediaRef",
                    attrs: {
                      player: _vm.player,
                      width: _vm.size,
                      height: 50,
                      id: `${_vm.player.playerId}-${this.chartId}`,
                      margin: _vm.margin,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      fontSize: _vm.mediaModeData.socialMediaFontSize,
                      fontWeight: _vm.mediaModeData.socialMediaFontWeight,
                      sponsor: _vm.mediaModeData.sponsor.dataUrl,
                      fontFamily: _vm.mediaModeData.fontFamily,
                      logoCfg: _vm.mediaModeData.logo,
                      type: "keyPassMap",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ChartExportLinksModal", {
        ref: "chartExportLinksModalRef",
        attrs: {
          title: _vm.player.name,
          subtitle: _vm.$t("playerDetail.keyPassMap"),
        },
      }),
      _vm._v(" "),
      _vm.currentUser.showTour &&
      _vm.playerSeasonData &&
      _vm.playerSeasonData.length
        ? _c("Tour", {
            attrs: { name: "playerKeyPassTour", steps: _vm.tourSteps },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }